export default __webpack_public_path__ + "static/media/total-input.eb520421.png";